class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.activeVideos = [];

    window.loadSwiper.then((swiper) => {
      this.swiperLib = swiper;
      this._initCarousel();
    });
  }

  connectedCallback() {
    this.handleVariantChange = (e) => {
      const { variant } = e.detail;

      if (!variant?.featured_media) return;

      const mediaId = parseInt(variant.featured_media?.id);

      this.querySelectorAll("[data-media-id]").forEach((media) => {
        media.style.display =
          parseInt(media.dataset.mediaId) === mediaId ? null : "none";
      });

      this.gallerySwiper?.slideToLoop(0);
    };

    document.addEventListener("variant:changed", this.handleVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener("variant:changed", this.handleVariantChange);
  }

  _initCarousel() {
    const { Swiper, Scrollbar } = this.swiperLib;

    const initSwiper = () => {
      if (this.gallerySwiper || !this._isMobile) return; // skip if not mobile

      let swiperParams = {
        modules: [Scrollbar],
        slidesPerView: "auto",
        loop: false,
        speed: 400,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        spaceBetween: 5,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
      };

      console.log(
        "this.querySelector(`.${this._prefix}__media-container`)",
        this.querySelector(`.${this._prefix}__media-container`),
      );
      this.gallerySwiper = new Swiper(
        this.querySelector(`.${this._prefix}__media-container`),
        swiperParams,
      );

      // this.gallerySwiper.on("slideChange", () => {
      //   const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
      //     slide.classList.contains("swiper-slide-visible"),
      //   );
      //   this._selectVideo(visibleSlides);
      // });
    };

    const destroySwiper = () => {
      if (this.gallerySwiper) {
        this.gallerySwiper.destroy(true, true);
        this.gallerySwiper = null;
      }
    };

    const handleResize = () => {
      if (this._isMobile) {
        initSwiper();
      } else {
        destroySwiper();
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // initialize on load
  }

  // _selectVideo(els) {
  //   this.activeVideos.forEach((video) => video.pause());

  //   this.activeVideos = [];

  //   els.forEach((el) => {
  //     const video = el.querySelector("video");

  //     if (video) {
  //       this.activeVideos.push(video);
  //       video.play();
  //     }
  //   });
  // }

  get _prefix() {
    return this.dataset.classPrefix;
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }
}

if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}
